import React, { useState, useRef, useEffect } from "react";
import { FaIdBadge, FaUser } from "react-icons/fa";
import { Chart as ChartJS } from "chart.js/auto";
import { FaUserFriends } from "react-icons/fa";
import "./RD.css";
import { toast } from "react-toastify";

const RD = () => {
  const [amount, setAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [relation, setRelation] = useState("");
  const [idProof, setIdProof] = useState("");
  const [referralId, setReferralId] = useState("");
  const [referralName, setReferralName] = useState("");
   const [step, setStep] = useState(1);
    const [nomineeLoading, setNomineeLoading] = useState(false);
  const [transferDate, setTransferDate] = useState("");

  // Payment Mode
  const [paymentMode, setPaymentMode] = useState("");

  // Cash
  const [receiptNumber, setReceiptNumber] = useState("");

  // Cheque
  const [chequeNumber, setChequeNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [chequeDate, setChequeDate] = useState("");

  // Online
  const [upiId, setUpiId] = useState("");
  const [transactionId, setTransactionId] = useState("");

  // Handler for payment mode
   const handlePaymentModeChange = (e) => {
  setPaymentMode(e.target.value);

  // Reset fields
  setReceiptNumber("");
  setChequeNumber("");
  setBankName("");
  setChequeDate("");
  setUpiId("");
  setTransactionId("");
};

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", { transferDate });
  };
  
    // Customer states
    const [customerId, setCustomerId] = useState("");
    const [customerData, setCustomerData] = useState({
      name: "",
      parent: "",
      aadhar: "",
      pan: "",
      mobile: "",
      address: "",
    });
    const [customerLoading, setCustomerLoading] = useState(false);
  
    // Nominee states
    const [nomineeId, setNomineeId] = useState("");
    const [nomineeData, setNomineeData] = useState({
      nomineeName: "",
      dob: "",
      aadhar: "",
      pan: "",
      mobile: "",
      address: "",
    });
  
   
  
    // Mock API fetch for customer
    const fetchCustomer = async (id) => {
      setCustomerLoading(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          setCustomerLoading(false);
          resolve({
            name: "John Doe",
            parent: "Mr. Doe",
            aadhar: "123412341234",
            pan: "ABCDE1234F",
            mobile: "9876543210",
            address: "123 Main Street",
          });
        }, 1000);
      });
    };
  
    // Mock API fetch for nominee
    const fetchNominee = async (id) => {
      setNomineeLoading(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          setNomineeLoading(false);
          resolve({
            nomineeName: "Jane Doe",
            dob: "2000-01-01",
            aadhar: "432143214321",
            pan: "XYZAB1234C",
            mobile: "9876501234",
            address: "456 Side Street",
          });
        }, 1000);
      });
    };
  
    // Fetch customer when ID is entered
    useEffect(() => {
      if (customerId) {
        fetchCustomer(customerId).then((data) => setCustomerData(data));
      } else {
        setCustomerData({
          name: "",
          parent: "",
          aadhar: "",
          pan: "",
          mobile: "",
          address: "",
        });
      }
    }, [customerId]);
  
    // Fetch nominee when nominee ID is entered
    useEffect(() => {
      if (nomineeId) {
        fetchNominee(nomineeId).then((data) => setNomineeData(data));
      } else {
        setNomineeData({
          nomineeName: "",
          dob: "",
          aadhar: "",
          pan: "",
          mobile: "",
          address: "",
        });
      }
    }, [nomineeId]);
  
    const isNomineeValid = () => {
      const { nomineeName, dob, aadhar, pan, mobile, address } = nomineeData;
      return nomineeId && nomineeName && dob && aadhar && pan && mobile && address && relation && idProof;
    };
  
    const resetStep1 = () => setCustomerId("");
    const resetStep2 = () => {
      setNomineeId("");
      setNomineeData({
        nomineeName: "",
        dob: "",
        aadhar: "",
        pan: "",
        mobile: "",
        address: "",
      });
      setRelation("");
      setIdProof("");
    };
    const resetStep3 = () => {
      setReferralId("");
      setReferralName("");
    };
  

     

    // Customer fields mapped to display like Nominee style
    const customerFields = [
      { label: "Customer ID", key: "customerId", value: customerId, required: true },
      { label: "CUS Name", key: "name", value: customerData.name, required: true },
      { label: "Parent's Name", key: "parent", value: customerData.parent, required: true },
      { label: "Aadhar", key: "aadhar", value: customerData.aadhar, required: true },
      { label: "PAN", key: "pan", value: customerData.pan, required: true },
      { label: "Mobile", key: "mobile", value: customerData.mobile, required: true },
      { label: "Address", key: "address", value: customerData.address, required: true },
    ];

  const [results, setResults] = useState({
    principal: 0,
    totalInterest: 0,
    maturityAmount: 0,
  });

  const [viewChart, setViewChart] = useState(false);
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  // ✅ ChartJS initialization
  useEffect(() => {
    if (viewChart && canvasRef.current) {
      if (chartRef.current) {
        chartRef.current.destroy();
      }

      chartRef.current = new ChartJS(canvasRef.current, {
        type: "doughnut",
        data: {
          labels: ["Principal", "Interest"],
          datasets: [
            {
              data: [results.principal, results.totalInterest],
              backgroundColor: ["#018da0ff", "#F59E0B"],
              hoverOffset: 10,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
              labels: { font: { size: 14 } },
            },
          },
        },
      });
    }

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [viewChart, results]);

  const handleCalculate = (e) => {
    e.preventDefault();
    const principal = Number(amount || 0) * Number(tenure || 0);
    const totalInterest = (principal * 7) / 100;
    const maturityAmount = principal + totalInterest;
    setResults({ principal, totalInterest, maturityAmount });
  };

  const resetForm = () => {
    setAmount("");
    setTenure("");
    setRelation("");
    setIdProof("");
    setReferralId("");
    setReferralName("");
    setResults({ principal: 0, totalInterest: 0, maturityAmount: 0 });
  };

  const handleFinalSubmit = () => {
    toast.success("RD Account Submitted ✅");
    // later → send data to backend API
  };

  return (
    <div className="RD-container">
      {/* Top Form Section */}
      <form onSubmit={handleCalculate}>
        <div className="RD-form-grid">
          {/* Account Info */}
          <div className="RD-field">
            <label htmlFor="accountType" className="RD-label">Account Type :</label>
            <select id="accountType" className="RD-input">
              <option>RD</option>
            </select>
          </div>

          <div className="RD-field">
            <label htmlFor="rdType" className="RD-label">RD Type :</label>
            <select id="rdType" className="RD-input">
              <option>Regular</option>
              <option>Senior Citizen</option>
              <option>NRE/NRI RD</option>
            </select>
          </div>

          <div className="RD-field">
            <label className="RD-label">Select Scheme :</label>
            <select className="RD-input">
              <option>RD Deposit</option>
            </select>
          </div>

          <div className="RD-field">
            <label className="RD-label">ROI :</label>
            <input type="text" value="7" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label className="RD-label">Min Deposit Amount :</label>
            <input type="text" value="10000.00" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label className="RD-label">Min Deposit Tenures (In Months) :</label>
            <input type="text" value="36" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label className="RD-label">Lockin Period (In Months) :</label>
            <input type="text" value="1" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label className="RD-label">Interest Lockin (In Months) :</label>
            <input type="text" value="7" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label className="RD-label">Opening Date :</label>
            <input type="date" className="RD-input" />
          </div>

          <div className="RD-field">
            <label className="RD-label">Compounding Type :</label>
            <input type="text" value="Simple" className="RD-input read-only" readOnly />
          </div>

          <div className="RD-field">
            <label htmlFor="loanAmount" className="RD-label">Enter Loan Amount :</label>
            <input
              id="loanAmount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="RD-input"
              placeholder="Enter amount"
            />
          </div>

          <div className="RD-field">
            <label htmlFor="tenure" className="RD-label">Enter Tenure (In Months) :</label>
            <input
              id="tenure"
              type="number"
              value={tenure}
              onChange={(e) => setTenure(Number(e.target.value))}
              className="RD-input"
              placeholder="Enter tenure in months"
            />
          </div>
        </div>

        {/* Form Actions */}
        <div className="RDbtn-actions">
          <button type="submit" className="RDbtn-calc">Calculate</button>
          <button type="button" className="RDbtn-reset" onClick={resetForm}>Reset</button>

          <label className="RDchart-toggle">
            <input
              type="checkbox"
              checked={viewChart}
              onChange={(e) => setViewChart(e.target.checked)}
            />
            <span className="RDslider"></span>
            <span className="RDtoggle-label">
              {viewChart ? "View" : "Close"} Chart
            </span>
          </label>
        </div>
      </form>

      {/* Results */}
      <div className="RD-result card">
        <div className="RDcard-header">Results</div>
        <div className="RDresults-grid">
          <div className="RDresults-info">
            <div className="RDresult-row">
              <div className="RDlabel">Principal Amount:</div>
              <div className="RDvalue">{results.principal.toLocaleString()}</div>
            </div>
            <div className="RDresult-row">
              <div className="RDlabel">Total Interest:</div>
              <div className="RDvalue">{results.totalInterest.toLocaleString()}</div>
            </div>
            <div className="RDresult-row">
              <div className="RDlabel">Maturity Amount:</div>
              <div className="RDvalue">{results.maturityAmount.toLocaleString()}</div>
            </div>
          </div>

          {viewChart && (
            <div className="RDchart-wrap">
              <canvas ref={canvasRef} className="RD-canvas"></canvas>
            </div>
          )}
        </div>
      </div>

      <div className="RDcustomer-container">
  <h1 className="RDh1">Customer & Nominee Form</h1>
  <div className="RD-bar">
    <div className="RDprogress" style={{ width: `${(step / 3) * 100}%` }}></div>
  </div>

  {/* Step 1: Customer Details */}
  {step === 1 && (
    <div className="RDNom-card animated-card">
      <h2><FaUser /> Customer Details</h2>

      {customerFields.map(({ label, key, value, required }) => (
        <div className="RDNom-row-box" key={key}>
          <div className="RDNom-label-cell">
            {label} {required && <span className="RDrequired">*</span>}
          </div>
          <div className="RDNom-value-cell">
            <input
              type="text"
              placeholder={label}
              value={key === "customerId" ? customerId : value}
              onChange={(e) =>
                key === "customerId"
                  ? setCustomerId(e.target.value)
                  : setCustomerData({ ...customerData, [key]: e.target.value })
              }
              disabled={key !== "customerId"}
            />
          </div>
        </div>
      ))}

      {customerLoading && <p className="RDloading-text">Loading customer data...</p>}

      <div className="RDstep-buttons">
        <button
          className="RDnext-btn"
          onClick={() => setStep(2)}
          disabled={!customerId || customerLoading}
        >
          Next: Nominee Details
        </button>
        <button className="RDreset-btn" onClick={resetStep1}>Reset</button>
      </div>
    </div>
  )}

  {/* Step 2: Nominee Details */}
  {step === 2 && (
    <div className="RDNom-card animated-card">
      <h2><FaUserFriends /> Nominee Details</h2>

      {nomineeLoading && <p className="RDloading-text">Loading nominee data...</p>}

      {[
        { label: "Nominee ID", key: "nomineeId", value: nomineeId, required: true },
        { label: "Name", key: "nomineeName", value: nomineeData.nomineeName, required: true },
        { label: "DOB", key: "dob", value: nomineeData.dob, type: "date", required: true },
        { label: "Aadhar", key: "aadhar", value: nomineeData.aadhar, required: true },
        { label: "PAN", key: "pan", value: nomineeData.pan, required: true },
        { label: "Mobile", key: "mobile", value: nomineeData.mobile, required: true },
        { label: "Address", key: "address", value: nomineeData.address, required: true },
      ].map(({ label, key, value, type, required }) => (
        <div className="RDNom-row-box" key={key}>
          <div className="RDNom-label-cell">
            {label} {required && <span className="RDrequired">*</span>}
          </div>
          <div className="RDNom-value-cell">
            <input
              type={type || "text"}
              placeholder={label}
              value={key === "nomineeId" ? nomineeId : value}
              onChange={(e) =>
                key === "nomineeId"
                  ? setNomineeId(e.target.value)
                  : setNomineeData({ ...nomineeData, [key]: e.target.value })
              }
            />
          </div>
        </div>
      ))}

      <div className="RDNom-row-box">
        <div className="RDNom-label-cell">Nominee Relation <span className="RDrequired">*</span></div>
        <div className="RDNom-value-cell">
          <select value={relation} onChange={(e) => setRelation(e.target.value)}>
            <option value="">Select Relation</option>
            <option value="Father">Father</option>
            <option value="Mother">Mother</option>
            <option value="Spouse">Spouse</option>
            <option value="Son">Son</option>
            <option value="Daughter">Daughter</option>
          </select>
        </div>
      </div>

      {relation && (
        <div className="RDNom-row-box">
          <div className="RDNom-label-cell">ID Proof <span className="RDrequired">*</span></div>
          <div className="RDNom-value-cell">
            <select value={idProof} onChange={(e) => setIdProof(e.target.value)}>
              <option value="">Select ID Proof</option>
              <option value="Aadhar">Aadhar</option>
              <option value="PAN">PAN</option>
              <option value="VoterID">Voter ID</option>
            </select>
          </div>
        </div>
      )}

      {idProof && (
        <div className="RDNom-row-box">
          <div className="RDNom-label-cell">Choose File <span className="RDrequired">*</span></div>
          <div className="RDNom-value-cell">
            <input type="file" />
          </div>
        </div>
      )}

      <div className="RDstep-buttons">
        <button
          className="RDnext-btn"
          onClick={() => setStep(3)}
          disabled={!isNomineeValid() || nomineeLoading}
        >
          Next: Referral Details
        </button>
        <button className="RDprev-btn" onClick={() => setStep(1)}>Back</button>
        <button className="RDreset-btn" onClick={resetStep2}>Reset</button>
      </div>
    </div>
  )}

  {/* Step 3: Referral Details */}
  {step === 3 && (
    <div className="RDRef-card animated-card">
      <h2><FaIdBadge /> Referral Details</h2>

      <div className="RDRef-row-horizontal">
        <div className="RDRef-column">
          <label><FaIdBadge /> Referral ID <span className="RDrequired">*</span></label>
          <input
            type="text"
            placeholder="Enter Referral ID"
            value={referralId}
            onChange={(e) => setReferralId(e.target.value)}
          />
        </div>
        <div className="RDRef-column">
          <label><FaUser /> Referral Name <span className="RDrequired">*</span></label>
          <input
            type="text"
            placeholder="Enter Referral Name"
            value={referralName}
            onChange={(e) => setReferralName(e.target.value)}
          />
        </div>
      </div>

      <div className="RDstep-buttons">
        <button
          type="submit"
          className="RDsub"
          disabled={!referralId || !referralName}
          onClick={() => alert("Account opened successfully! 🎉")}
        >
          Open Saving Account
        </button>
        <button className="RDprev-btn" onClick={() => setStep(2)}>Back</button>
        <button className="RDreset-btn" onClick={resetStep3}>Reset</button>
      </div>
    </div>
  )}
</div>

 <div className="RDpayment-form-container">
    <h2 className="RDform-title">Make a Payment</h2>
    <form onSubmit={handleSubmit}>
        {/* Amount */}
        <div className="RDform-row">
    <div className="RDform-group">
        <label htmlFor="RDamount">Amount</label>
        <div className="RDamount-input-group">
            <span className="RDcurrency-symbol">₹</span>
            <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />
        </div>
    </div>

    <div className="RDform-group">
        <label htmlFor="transferDate">Transfer Date</label>
        <input
            type="date"
            id="transferDate"
            value={transferDate}
            onChange={(e) => setTransferDate(e.target.value)}
        />
    </div>
</div>


        {/* Payment Mode */}
<div className="RDform-group payment-mode-group">
  <label>Payment Mode</label>
  <div className="RDradio-options">
    <label>
      <input
        type="radio"
        name="paymentMode"
        value="cash"
        checked={paymentMode === "cash"}
        onChange={handlePaymentModeChange}  
      />
      Cash
    </label>
    <label>
      <input
        type="radio"
        name="paymentMode"
        value="cheque"
        checked={paymentMode === "cheque"}
        onChange={handlePaymentModeChange} 
      />
      Cheque
    </label>
    <label>
      <input
        type="radio"
        name="paymentMode"
        value="online"
        checked={paymentMode === "online"}
        onChange={handlePaymentModeChange}  
      />
      Online Transaction
    </label>
  </div>
</div>


        {/* Conditional Fields */}
        {paymentMode === 'cash' && (
            <div className="RDcash-fields form-group">
                <label htmlFor="receiptNumber">Receipt Number</label>
                <input
                    type="text"
                    id="receiptNumber"
                    placeholder="Enter Cash Receipt Number"
                    value={receiptNumber}
                    onChange={(e) => setReceiptNumber(e.target.value)}
                />
            </div>
        )}

        {paymentMode === 'cheque' && (
            <div className="RDcheque-fields">
                <div className="RDform-group">
                    <label htmlFor="chequeNumber">Cheque Number</label>
                    <input
                        type="text"
                        id="chequeNumber"
                        placeholder="Enter Cheque Number"
                        value={chequeNumber}
                        onChange={(e) => setChequeNumber(e.target.value)}
                    />
                </div>
                <div className="RDform-group">
                    <label htmlFor="bankName">Bank Name</label>
                    <input
                        type="text"
                        id="bankName"
                        placeholder="Enter Bank Name"
                        value={bankName}
                        onChange={(e) => setBankName(e.target.value)}
                    />
                </div>
                <div className="RDform-group">
                    <label htmlFor="chequeDate">Cheque Date</label>
                    <input
                        type="date"
                        id="chequeDate"
                        value={chequeDate}
                        onChange={(e) => setChequeDate(e.target.value)}
                    />
                </div>
            </div>
        )}

        {paymentMode === 'online' && (
            <div className="RDonline-fields">
                <div className="RDform-group">
                    <label htmlFor="upiId">UPI ID or Account Number</label>
                    <input
                        type="text"
                        id="upiId"
                        placeholder="Enter UPI ID or Bank Account Number"
                        value={upiId}
                        onChange={(e) => setUpiId(e.target.value)}
                    />
                </div>
                <div className="RDform-group">
                    <label htmlFor="transactionId">Transaction ID</label>
                    <input
                        type="text"
                        id="transactionId"
                        placeholder="Enter Transaction ID"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                    />
                </div>
            </div>
        )}

        {/* Submit Button */}
        <button type="submit" className="RDsubmit-button">
            Open RD Account
        </button>
        </form></div>
    </div>
  );
};

export default RD;
